<template>
   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

         <CardUpdatableHeader :row="row" :level="level"/>

         <v-card-text>
            <v-container>
            <v-row>
               <v-col cols="12">
                  <v-text-field v-model="row.equ_name" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts._required_name')" :rules="level.dialogOptions.codeRules" required :hint="$t('hints._name')" persistent-hint>
                  </v-text-field>
               </v-col>
            </v-row>
            <template v-if="!row.eqt_is_virtual">
               <h4>{{ $t('subtitles.equ_rack') }}</h4>
               <v-row>
                  <v-col cols="12">
                     <ddoSelect2
                        :callbacks="RCKcallbacks"
                        ref="mySelectRCK"
                        :options="RCKoptions"
                     >
                        <template v-slot:selection="data">
                           <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                           >
                              <span>{{data.item.dtc_code}} / {{data.item.dtr_code}} / {{data.item.rck_code}}</span>
                           </v-chip>
                        </template>

                        <template v-slot:item="data">
                           <v-list-item-content>
                              <v-list-item-title>{{data.item.dtc_code}} / {{data.item.dtr_code}} / {{data.item.rck_code}}</v-list-item-title>
                           </v-list-item-content>
                        </template>
                     </ddoSelect2>
                  </v-col>
               </v-row>
               <h4>{{ $t('subtitles.equ_positions') }}</h4>
               <v-row v-if="row.rck_size_u && !row.eqt_is_virtual">
                  <v-col cols="12">
                     <v-range-slider
                        v-model="row.equ_positions"
                        class="align-center"
                        :max="row.rck_size_u"
                        min=1
                        thumb-label="always"
                        thumb-size=24
                        :label="$t('texts.equ_positions')"
                        :hint="$t('hints.equ_positions')"
                        step=1
                        ticks="always"
                     >
                        <template v-slot:append>
                           {{ row.rck_size_u }}U
                        </template>
                     </v-range-slider>
                  </v-col>
                  <v-col cols="12">
                     <v-switch
                        dense
                        v-model="row.equ_on_front"
                        :label="$t('texts.equ_on_front')"
                        :disabled="level.dialogValues.form_delete" 
                     >
                     </v-switch>
                  </v-col>
               </v-row>
            </template>
            <h4>{{ $t('subtitles.equ_properties') }}</h4>
            <v-row>
               <v-col cols="12" sm="6">
                  <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelectPLF" :options="PLFoptions"/>
               </v-col>
               <v-col cols="12" sm="6">
                  <ddoSelectEquipmenttype :callbacks="EQTcallbacks" ref="mySelectEQT" :options="EQToptions"/>
               </v-col>
            </v-row>
            <v-row>
               <v-col v-if="!level.dialogValues.form_create" cols="12">
                  <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.equ_create,'long') }}<br/>
                  <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.equ_update,'long') }}
               </v-col>
            </v-row>
            <v-container v-if="!level.dialogValues.form_create">
               <h4>{{ $t('subtitles.equ_networks') }}</h4>
               <v-row>
                  <v-col cols="12">
                     <ddoClientList name="StartingNICMACIPAList" key="StartingNICMACIPAList" :level="levels[0]"
                        :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
                        ref="myNICMACIPAist"
                        >
                           <template v-slot:header="{ errors }">
                              <span></span>
                           </template>

                           <template slot="ipa_last_detect" slot-scope="props">
                              <span class="headline">{{ $api._d(props.row.ipa_last_detect,'long') }}</span>
                           </template>

                     </ddoClientList>
                  </v-col>
               </v-row>
            </v-container>
            <v-container>
               <v-row>
                  <v-col v-if="!level.dialogValues.form_create" cols="12">
                     <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.equ_create,'long') }}<br/>
                     <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.equ_update,'long') }}
                  </v-col>
               </v-row>
            </v-container>
         </v-container>
            <small>*{{ $t('texts.requiredfield') }}</small>
         </v-card-text>

         <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
   </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue';
import ddoSelectEquipmenttype from '@/components/ddoSelectEquipmenttype.vue';
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoClientList from '@/components/ddoClientList.vue';

export default {
   name: 'CardUpdatableEquipment',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelectPlatform,
      ddoSelectEquipmenttype,
      ddoSelect2,
      ddoClientList,
   },

   data: function () {
      return {
         selectedPLF: {},
         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "plf_name",
            item_value: "plf_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.platform'),
         },

         selectedEQT: {},
         EQTcallbacks: {},
         EQToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "eqt_name",
            item_value: "eqt_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.equipmenttype'),
         },

         selectedRCK: {},
         RCKcallbacks: {},
         RCKoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "rck_name",
            item_value: "rck_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.rack'),
         },

         levels: [
         {
            /* 
             * LEVEL 1 : all for NIC+MAC+IPA list
             */
            api_code: 'equipment',
            api_prefix: 'equ',
            row: {},
            level: 0,
            errors: [],
            columns: [ 'nic_name', 'mac_address', 'ipa_address', 'ipa_last_detect' ],
            customSlotNames: ['ipa_last_detect'],
            searchValues: {
            },
            options: {
               showChildRowToggler: false,
               preserveState: true,
               withChild: false,
               headings: {
                  _pk: i18n.t('headers.actions'),
                  equ_pk: '#',
                  equ_name: i18n.t('texts.equ_name'),
                  eqt_name: i18n.t('texts.eqt_name'),
                  equ_location: i18n.t('headers.equ_location'),
                  equ_position_from: i18n.t('headers.equ_position_from'),
                  _update: i18n.t('headers.updated_on'),
               },
               filterable: false,
               sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
            },
            callbacks: {
            },
         },

         ],

      }
   },

   created() {
      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;

      this.EQTcallbacks.refresh_rows = this.build_select_eqt;
      this.EQTcallbacks.change       = this.change_eqt;

      this.RCKcallbacks.refresh_rows = this.build_select_rck;
      this.RCKcallbacks.change       = this.change_rck;
   },

   mounted() {
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;   
   },

   watch: {
      row: 'loadOtherInformations',
   },

   methods: {

      async refresh_rows_l1(key) {
         // key parameter is NULL. this.row contains current EQU row
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+this.row._pk+'/nicmacips');
         this.loading = false;
         return { errorinfos, api_response }
      },

      async loadOtherInformations(row,oldRow) {
         if ( row.rck_size_u && row.equ_position_from ) {
            if ( row.equ_position_to==null ) {
               row.equ_position_to = row.equ_position_from;
            }
            row.equ_positions = [ row.equ_position_from, row.equ_position_to ]
            if ( row.equ_on_front==null ) {
               row.equ_on_front = true;
            }
         }
         if ( row._pk && this.$refs.myNICMACIPAist ) {
            this.$refs.myNICMACIPAist.refresh_rows();
         }
      },

      async build_select_plf(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'platform');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedPLF
       */
      async change_plf(value,item=null) {
         this.row.plf_pk = value;
         if ( item!=null ) {
            this.selectedPLF = item;
         } else {
            this.selectedPLF = this.$api._get_by_pk(this.$refs.mySelectPLF.items,value);
         }
      },

      async build_select_eqt(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'equipmenttype');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedEQT
       */
      async change_eqt(value,item=null) {
         this.row.eqt_pk = value;
         if ( item!=null ) {
            this.selectedEQT = item;
         } else {
            this.selectedEQT = this.$api._get_by_pk(this.$refs.mySelectEQT.items,value);
         }
      },

      async build_select_rck(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'rack');
         this.loading = false;
         return { errorinfos, api_response }
      },

      /*
       * this dropdown is 'return_object=false'. So, value is an integer, and item is null
       * We have to retrieve item from <select-reference>.items, and store it in this.selectedRCK
       */
      async change_rck(value,item=null) {
         this.row.rck_pk = value;
         if ( item!=null ) {
            this.selectedRCK = item;
         } else {
            this.selectedRCK = this.$api._get_by_pk(this.$refs.mySelectRCK.items,value);
            this.level.row.rck_size_u = this.selectedRCK.rck_size_u;
         }
      },

   },

}
</script>